<svg
  width="35"
  height="35"
  viewBox="0 0 55 55"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <g id="loader">
    <path
      id="ellipse-1"
      d="M2.91592 15.1763C5.69092 9.64057 10.253 5.20341 15.8637 2.5832C21.4744 -0.0370191 27.8052 -0.686914 33.8312 0.738727C39.8572 2.16437 45.2257 5.58209 49.0675 10.4386C52.9094 15.2951 54.9996 21.3061 55 27.4984C55.0004 33.6908 52.9107 39.702 49.0695 44.559C45.2282 49.4159 39.8601 52.8342 33.8342 54.2606C27.8084 55.6869 21.4775 55.0377 15.8665 52.4181C10.2556 49.7985 5.69294 45.3619 2.91731 39.8265L10.4261 36.0613C12.354 39.9059 15.5229 42.9874 19.42 44.8068C23.3171 46.6263 27.7142 47.0771 31.8994 46.0865C36.0847 45.0958 39.8131 42.7216 42.481 39.3483C45.149 35.9749 46.6003 31.7998 46.6001 27.4989C46.5998 23.198 45.148 19.0231 42.4797 15.65C39.8113 12.277 36.0827 9.90319 31.8973 8.91302C27.712 7.92284 23.3149 8.37422 19.418 10.1941C15.5212 12.014 12.3525 15.0958 10.4252 18.9406L2.91592 15.1763Z"
      fill="#494949" />
    <path
      id="ellipse-2"
      d="M43.0406 35.5462C41.2315 39.0402 38.2978 41.8227 34.7129 43.4444C31.1281 45.0661 27.1013 45.4324 23.2827 44.4842C19.464 43.536 16.0764 41.3286 13.6665 38.2184C11.2566 35.1082 9.96521 31.2765 10.0007 27.3421C10.0362 23.4077 11.3966 19.6 13.8622 16.5337C16.3277 13.4675 19.7547 11.3216 23.5898 10.4424C27.425 9.56329 31.4445 10.0022 34.9995 11.6884C38.5545 13.3745 41.4375 16.2094 43.1832 19.7356L35.426 23.576C34.5437 21.794 33.0867 20.3613 31.2901 19.5091C29.4934 18.657 27.4621 18.4352 25.5239 18.8795C23.5857 19.3238 21.8538 20.4083 20.6077 21.9579C19.3617 23.5075 18.6742 25.4318 18.6563 27.4202C18.6383 29.4086 19.291 31.345 20.5089 32.9168C21.7267 34.4887 23.4388 35.6043 25.3687 36.0835C27.2985 36.5627 29.3336 36.3775 31.1453 35.5579C32.957 34.7384 34.4396 33.3322 35.3539 31.5663L43.0406 35.5462Z"
      fill="#494949" />
    <circle
      id="ellipse-3"
      cx="27.5"
      cy="27.5"
      r="7.5"
      fill="#494949" />
  </g>
</svg>
